import { Flow, sectionTypes } from '@playbooks/action-cards-utils/src'
import { CheckedIcon, PauseIcon, StopIcon } from './ui'
import { useTranslation } from '../contexts/localization/Localization'
import scrollIntoView from '../utils/scrollIntoView'
import { useAppContext } from '../contexts/AppContext'

export default function FlowButton() {
  const { text } = useTranslation()
  const { data: state, rootRef: root, flowData, update } = useAppContext()
  const isUiSimple = state.isUiSimple

  const openAndScroll = () => {
    if (!state.actionCardFlow || !root.current) return

    const el = root.current.querySelector(`#label${flowData.responseId}`)!
    const section = el.closest('[data-section]')!
    const [secId, headerId] = section.id.split('|').map(el => +el)

    state.sections.forEach(sec => {
      if (sec.id === secId || sec.id === headerId) {
        sec.isOpened = true
        if (isUiSimple && sec.type !== sectionTypes.SEPARATOR) {
          sec.isSectionMinimized = false
        }
      }
    })

    el!.classList.add('illuminated-text')

    update()

    const scrollIntoViewElement = root.current.querySelector(
      '[data-role="data-action-cards-sides-scroll-container"]',
    ) as HTMLDivElement

    if (!root.current) return

    scrollIntoView({
      scrollIntoViewElement: el,
      scrollContainerRef: scrollIntoViewElement,
      onAfterScroll: () => {
        // 3000 ms is a class keeping time to illuminate an element
        setTimeout(() => el!.classList.remove('illuminated-text'), 3000)
      },
    })
  }

  if (!flowData) return null

  return (
    <div
      className={`flex pl-2 ${
        flowData.flow === Flow.STOP || flowData.flow === Flow.PAUSE ? 'bg-white dark:bg-black top-0' : ''
      }`}
    >
      <div className={`group`}>
        {flowData.flow === Flow.STOP && (
          <div
            onClick={openAndScroll}
            className="flex cursor-pointer items-center bg-white dark:bg-black rounded-lg p-1"
          >
            <StopIcon />
            <div className="ml-1 text-gray-500 text-[12px] group-hover:text-active whitespace-nowrap">
              {text('stopIt')}
            </div>
          </div>
        )}
        {flowData.flow === Flow.PAUSE && (
          <div
            onClick={openAndScroll}
            className="flex cursor-pointer items-center bg-white dark:bg-black rounded-lg p-1"
          >
            <PauseIcon />
            <div className="ml-1 text-gray-500 text-[12px] group-hover:text-active whitespace-nowrap">
              {text('paused')}
            </div>
          </div>
        )}
        {flowData.flow === Flow.COMPLETE && (
          <div
            onClick={openAndScroll}
            className="flex cursor-pointer items-center bg-white dark:bg-black rounded-lg p-1"
          >
            <CheckedIcon color="green" />

            <div className="ml-1 text-gray-500 text-[12px] group-hover:text-active whitespace-nowrap">
              {text('complete')}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
